/**
 * @file isElementSizeEqual
 * @author yuzong(yuzong@tencent.com)
 */
export function isElementSizeEqual(a, b) {
  return a.width === b.width && a.height === b.height;
}